export const colorNames = new Map([
    ['B', 'Blue'],
    ['Y', 'Yellow'],
    ['P', 'Purple'],
    ['R', 'Red'],
    ['O', 'Orange'],
    ['G', 'Green']
]);

export const colorKeys = new Map([
    ['Y', 'F6'],
    ['G', 'F7'],
    ['B', 'F8'],
    ['P', 'F9'],
    ['O', 'F10'],
    ['R', 'F5+F10'],
]);

export const figureNames = new Map([
    ['C', 'Clubs'],
    ['S', 'Spades'],
    ['D', 'Diamonds'],
    ['H', 'Hearts'],
]);

export const figureKeys = new Map([
    ['S', 'F1'],
    ['H', 'F2'],
    ['D', 'F3'],
    ['C', 'F4'],
]);

export const holes = [1, 2, 3, 4, 5, 6]
